import { Camera } from '../models/camera';
import { CameraParsed } from '../models/cameraParsed';
import { CamerasEntity } from './camerasEntity';

export const CamerasListValueObject = (data: CameraParsed[]): { list: Camera[] } => {
  return Object.freeze({
    list: data.map((item) => CamerasEntity(item)),
  });
};
